import { createContext } from "react";

const PermisosContext = createContext();

export default PermisosContext;
